import React from 'react'
import type { TFunction } from 'i18next'
import { getEfficiencyVariant } from '../electricityService'
import {
  ElectricityInsightCard,
  ElectricityInsightIcon,
  ElectricityInsightContent,
  ElectricityInsightTitle,
  ElectricityInsightText,
} from '../ElectricitySection.styles'

export interface InsightCardProps {
  rating: 'high' | 'medium' | 'low'
  t: TFunction
}

export const InsightCard: React.FC<InsightCardProps> = ({ rating, t }) => {
  const variant = getEfficiencyVariant(rating)

  const getIcon = () => {
    switch (variant) {
      case 'high':
        return '✓'
      case 'medium':
        return '⚖️'
      case 'low':
        return '⚠️'
      default:
        return '💡'
    }
  }

  const getRatingLabel = () => {
    switch (rating) {
      case 'high':
        return t('efficiency.high')
      case 'medium':
        return t('efficiency.medium')
      case 'low':
        return t('efficiency.low')
      default:
        return rating
    }
  }

  const getInsightMessage = () => {
    switch (variant) {
      case 'high':
        return t('insights.highEfficiency')
      case 'medium':
        return t('insights.mediumEfficiency')
      case 'low':
        return t('insights.lowEfficiency')
      default:
        return ''
    }
  }

  return (
    <ElectricityInsightCard $variant={variant}>
      <ElectricityInsightIcon>{getIcon()}</ElectricityInsightIcon>
      <ElectricityInsightContent>
        <ElectricityInsightTitle>
          {t('insights.title')}: {getRatingLabel()}
        </ElectricityInsightTitle>
        <ElectricityInsightText>{getInsightMessage()}</ElectricityInsightText>
      </ElectricityInsightContent>
    </ElectricityInsightCard>
  )
}
